<template>
  <div>
    <sf-modal :visible="xieyiOpen" class="HomeModal">
      <template #modal-bar>
        <div class="title" style="text-align:center;">
          <h4 style="padding:2rem;padding-top:1rem;margin:0;padding-bottom:0;">{{ xieYiData.title }}</h4>
        </div>
      </template>
      <template #close>
        <div>
          <sf-icon icon="cross" size="1.25rem" @click="closeXieyiModal" />
        </div>
      </template>
      <template #default>
        <div class="context">
          <div v-if="xieYiData.content" v-html="xieYiData.content" ref="ahtml"></div>
        </div>
      </template>
    </sf-modal>
  </div>
</template>
<script>
import { SfLink, SfIcon, SfButton, SfModal } from '@storefront-ui/vue';
import { ref, computed } from '@nuxtjs/composition-api';

export default {
  components: {
    SfLink,
    SfIcon,
    SfButton,
    SfModal
  },
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  setup(prop, { root: { context: { $cookies } }, root }) {
    const visable = ref(false);
    const ahtml = ref();
    const xieyiOpen = ref(false);
    const xieYiData = computed(() => {
      const regex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)"/gi;
      if (prop?.name === 'cookie') {
        if (root?.$options?.$mallConfig?.mall_web_config?.cookieXieyi) {
          const xieyi = JSON.parse(JSON.stringify(root?.$options?.$mallConfig?.mall_web_config.cookieXieyi));
          if (xieyi) {
            xieyi.content = xieyi?.content.replace(regex, (match, href) => {
              const locale = root?.$cookies.get('vsf-locale');
              if (!href.startsWith('http://') && !href.startsWith('https://')) {
                const updatedHref = `${'/' + locale}${href}`;
                const updatedAnchorTag = match.replace(href, updatedHref);
                return updatedAnchorTag;
              } else {
                return match;
              }
            });
            return xieyi;
          }
        }
      } else if (prop?.name === 'register') {
        if (root?.$options?.$mallConfig?.mall_web_config?.registerXieyi) {
          const register = JSON.parse(JSON.stringify(root?.$options?.$mallConfig?.mall_web_config.registerXieyi));
          if (register) {
            register.content = register?.content.replace(regex, (match, href) => {
              const locale = root?.$cookies.get('vsf-locale');
              if (!href.startsWith('http://') && !href.startsWith('https://')) {
                const updatedHref = `${'/' + locale}${href}`;
                const updatedAnchorTag = match.replace(href, updatedHref);
                return updatedAnchorTag;
              } else {
                return match;
              }
            });
            return register;
          }
        }
      } else {
        return {
          title: '',
          content: ''
        };
      }
    });
    const closeXieyiModal = () => {
      xieyiOpen.value = false;
    };
    const openModalXieYi = () => {
      xieyiOpen.value = true;
      try {
        var imgs = [];
        if (ahtml.value) {
          // 通过ref获取到所有有usemap的dom元素
          imgs = ahtml.value.querySelectorAll('img[usemap]');
        }
        // 通过遍历所有的dom元素，通过usemap的值获取到对应的map元素
        imgs?.forEach((img, index) => {
          // 获取img元素的height和width
          const alt = img.getAttribute('alt');
          if (index !== -1 && alt.indexOf('autosize1') !== -1) {
            // 对每个元素执行相应操作
            const mapName = img.useMap.replace('#', '');
            const map = ahtml.value.querySelector(`map[name=${mapName}]`);
            // 获取到map元素下所有的area元素
            const areas = map.querySelectorAll('area');
            // const imgWidth = img.width;
            // const imgHeight = img.height;
            const imgHeight = img.getAttribute('height');
            const imgWidth = img.getAttribute('width');
            // 遍历所有的area元素，获取到对应的href值
            const newImg = ahtml.value.querySelector('img[usemap=' + `"#${mapName}"` + ']');
            const newImgWidth = newImg.clientWidth;
            const newImgHeight = newImg.clientHeight;
            const widthRatio = Number(newImgWidth / imgWidth).toFixed(2);
            const heightRatio = Number(newImgHeight / imgHeight).toFixed(2);
            areas.forEach(area => {
              // 根据img按newimg的比例缩放area的坐标
              const coords = area.coords.split(',');
              const adjustedCoords = coords.map((value, index) => {

                const adjustedValue = index % 2 === 0 ? value * widthRatio : value * heightRatio;
                // 将每一个调整后的坐标值四舍五入到指定的小数位数
                return Number(adjustedValue.toFixed(2));
              }
              );
              area.style.backgroundColor = 'red';
              // 判断area.href有值且是已/开头
              //
              const href = area.getAttribute('href');
              const locale = root?.$cookies.get('vsf-locale');
              if (href && href.charAt(0) === '/' && locale) {
                area.setAttribute('href', `${ '/' + locale}${href}`);
              }
              area.coords = adjustedCoords;
            });
          } else if (index !== -1 && alt.indexOf('autosize0') !== -1) {
            // 对每个元素执行相应操作
            const mapName = img.useMap.replace('#', '');
            const map = ahtml.value.querySelector(`map[name=${mapName}]`);
            // 获取到map元素下所有的area元素
            const areas = map.querySelectorAll('area');
            areas.forEach(area => {
              const href = area.getAttribute('href');
              const locale = root?.$cookies.get('vsf-locale');
              if (href && href.charAt(0) === '/' && locale) {
                area.setAttribute('href', `${ '/' + locale}${href}`);
              }
            });
          }
        });
        const videos = ahtml.value?.querySelectorAll('video');
        videos?.forEach((video) => {
          if (video.autoplay) {
            setTimeout(() => {
              video.play();
            }, 1000);
          }
        });
      } catch (e) {
        console.log('e', e);
      }
    };
    return {
      visable,
      ahtml,
      xieyiOpen,
      xieYiData,
      closeXieyiModal,
      openModalXieYi
    }
  }
}
</script>
<style lang="scss" scoped>
.HomeModal{
  @include for-mobile {
    --modal-width: 80vw;
  }
  @include for-desktop {
    --modal-width: 60vw;
  }
}
.sf-modal__container {

  min-height: 10rem;

  .context {
    min-height: 5rem;
  }
}
</style>
